var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluefacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.487,
    height: 28.749,
    viewBox: "0 0 16.487 28.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-facebook",
    "data-name": "Icon feather-facebook",
    d: "M25.487,3H21.4a6.812,6.812,0,0,0-6.812,6.812V13.9H10.5v5.45h4.087v10.9h5.45v-10.9h4.087l1.362-5.45h-5.45V9.812A1.362,1.362,0,0,1,21.4,8.45h4.087Z",
    transform: "translate(-9.75 -2.25)",
    fill: "none",
    stroke: "#05235c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluefacebook);
export default __webpack_public_path__ + "static/media/bluefacebook.cd07b744cc557e219d1c9deb0c38fd73.svg";
export { ForwardRef as ReactComponent };